import PropTypes from 'prop-types';
import React from 'react';
import '../style.css';
import './style.css';

const RedButton = ({ children, type, disable, ...other }) => {
  const className = 'red-button box-button general-button';
  switch (type) {
    case 'file':
      return (
        <label className={className}>
          <input {...other} type={type} />
          {children}
        </label>
      );
    case 'submit':
      return (
        <button {...other} type="submit" className={className} disabled={disable}>
          {children}
        </button>
      );
    default:
      return (
        <button {...other} type="button" className={className} disabled={disable}>
          {children}
        </button>
      );
  }
};

RedButton.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  disable: PropTypes.bool
};

RedButton.defaultProps = {
  type: 'button',
  disable: false
};

export default RedButton;
